export const isUUID = str => {
  // Checks if a string is a valid UUID V4 the uuid we use for the assessment attempts
  return /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(
    str
  );
};
